import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ConsumptionFilter } from '../../stores/consumption.store';
import { GermanNumberPipe } from '../../../../shared/pipes/german-number-pipe';

@Component({
  selector: 'app-analysis-consumption-graph-tooltip',
  templateUrl: './analysis-consumption-graph-tooltip.html',
  imports: [DatePipe, GermanNumberPipe, TranslocoPipe],
})
export class AnalysisConsumptionGraphTooltip {
  timestamp = input<Date>();
  value = input<number>();
  granularity = input<ConsumptionFilter['granularity']>();
  graphView = input<ConsumptionFilter['view']>();
}
